import React from 'react'
import '../Styles/gallery.css'

import foto1 from "../Assets/cajas/caja1.jpg"
import foto2 from "../Assets/cajas/caja2.jpg"
import foto3 from "../Assets/cajas/caja3.jpg"
import foto4 from "../Assets/cajas/caja4.jpg"


const Gallery = () => {
    return (
        <div className="gal">
            <h1 className="titulo">CAJAS ALIMENTICIAS</h1>
            <div className="galeria" id="CAJAS">
                <a href="#imagenc1">
                    <img src={foto1} alt=""/>
                </a>
                <a href="#imagenc2">
                    <img src={foto2} alt=""/>
                </a>
                <a href="#imagenc3">
                    <img src={foto3} alt=""/>
                </a>
                <a href="#imagenc4">
                    <img src={foto4} alt=""/>
                </a>
            </div>

            <div className="light-box" id="imagenc1">  
                <a href="#imagenc5" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto1} alt=""/>
                <a href="#imagenc2" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close" >
                    X 
                </a>
            </div>

            <div className="light-box" id="imagenc2">  
                <a href="#imagenc1" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto2} alt=""/>
                <a href="#imagenc3" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>

            <div className="light-box" id="imagenc3">  
                <a href="#imagenc2" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto3} alt=""/>
                <a href="#imagenc4" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>

            <div className="light-box" id="imagenc4">  
                <a href="#imagenc3" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto4} alt=""/>
                <a href="#imagenc1" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>


        </div>
    )
}

export default Gallery
